import { ArcGisMapConfig } from "../models/ArcGisMapConfig";
import Map from "./Map";
import Point from "@arcgis/core/geometry/Point";

interface Props {
    point: Point | null;
    webMapItemId?: string;
    arcgisToken?: string;
}

const LocationViewer = ({ point, webMapItemId, arcgisToken }: Props) => {
    const mapConfig = {
        authAppId: process.env.REACT_APP_ARCGIS_APP_ID,
        portalUrl: process.env.REACT_APP_ARCGIS_PORTAL_URL,
    } as ArcGisMapConfig;

    return (
        <Map
            mapConfig={mapConfig}
            webMapItemId={webMapItemId}
            token={arcgisToken}
            center={point ?? undefined}
            items={point ? [{ geometry: point }] : []}
        ></Map>
    );
};

export default LocationViewer;
